// usePagination.js
import { useState } from 'react';

export const usePagination = (data, rowsPerPage) => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageCount = Math.ceil(data.length / rowsPerPage);

  return { currentPage, setCurrentPage, pageCount };
};